<div class="document-details-page">
  <div class="document-details-header">
    <geaui-page-header
      pageTitle="Document Details"
      [hasBackArrow]="true"
      [withSidebar]="true"
      (backArrowClicked)="goBack()"
    >
      <div class="header-content-actions">
        <geaui-icon-v3
          style="cursor: pointer"
          file="16px_share"
          color="black"
          title="Share"
          [clickable]="true"
          (click)="copyLink()"
        ></geaui-icon-v3>
        <geaui-icon-v3
          style="cursor: pointer"
          file="16px_bookmark"
          color="black"
          [clickable]="true"
          (click)="toggleBookmark(isBookmark)"
          [color]="'black'"
          title="Bookmark"
          [colorProp]="isBookmark ? 'fill' : 'stroke'"
        ></geaui-icon-v3>
      </div>
    </geaui-page-header>
  </div>

  <div class="document-details-content">
    <div class="details-container">
      <div class="detail-row">
        <span>Title</span>
        <span
          colspan="4"
          style="
            font-weight: bold;
            padding-left: 4px;
            font-size: 16px;
            color: rgb(0, 15, 65);
          "
        >
          &nbsp; {{ selectedDoc?.Title }}</span
        >
      </div>
      <div class="detail-row">
        <span>Language</span>
        <span colspan="4">&nbsp; {{ selectedDoc?.Language }}</span>
      </div>
      <div class="detail-row">
        <span>Document Id</span>
        <span colspan="4">&nbsp; {{ selectedDoc?.Id }}</span>
      </div>
      <div class="detail-row">
        <span>Document Type</span>
        <span colspan="4">&nbsp; {{ selectedDoc?.DocumentType }}</span>
      </div>
      <div class="detail-row">
        <span>File Type</span>
        <span colspan="4">&nbsp; {{ selectedDoc?.FileType }}</span>
      </div>
      <div class="detail-row">
        <span>File Size</span>
        <span colspan="4">&nbsp; {{ selectedDoc?.Size }} MB</span>
      </div>
      <div class="detail-row">
        <span>File Name</span>
        <span colspan="4">&nbsp; {{ selectedDoc?.OriginalFileName }}</span>
      </div>
      <div class="detail-row">
        <span>Keywords</span>
        <span colspan="4">&nbsp; {{ selectedDoc?.Keywords }}</span>
      </div>
    </div>
  </div>
  <geaui-button-v2
    type="primary"
    [style]="'margin-left: 410px;'"
    (click)="downloadDocument(selectedDoc)"
  >
    <span class="custom-button-content">
      <geaui-icon-v3 file="16px_download" color="white"></geaui-icon-v3>
      Download
    </span>
  </geaui-button-v2>
</div>
